import { createUniqueId } from 'solid-js'

export function SeasonalTreeIcon() {
  // Minted per instance, so copies of one icon never resolve url(#…) to
  // each other's defs
  const id = createUniqueId()
  const paint0 = `seasonal-tree-icon-${id}-paint0`
  const paint1 = `seasonal-tree-icon-${id}-paint1`
  const clip0 = `seasonal-tree-icon-${id}-clip0`

  return (
    <svg
      width="46"
      height="46"
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <g clip-path={`url(#${clip0})`}>
        <path
          d="M40.4968 12.97V30.28C40.4968 35.23 36.4768 39.25 31.5268 39.25H14.4768C9.52682 39.25 5.50683 35.23 5.50683 30.28V12.97C5.49683 8.02 9.51683 4 14.4668 4L31.5168 4C36.4768 4 40.4968 8.02 40.4968 12.97Z"
          fill={`url(#${paint0})`}
        />
        <path
          d="M31.5168 8H14.4768C11.7264 8 9.49683 10.2296 9.49683 12.98V30.28C9.49683 33.0304 11.7264 35.26 14.4768 35.26H31.5168C34.2672 35.26 36.4968 33.0304 36.4968 30.28V12.98C36.4968 10.2296 34.2672 8 31.5168 8Z"
          fill={`url(#${paint1})`}
        />
        <path
          d="M23.5868 27.3101H22.4068C21.9168 27.3101 21.5268 26.9101 21.5268 26.4301V22.2201C21.5268 22.2201 21.5668 22.1401 21.6068 22.1401H24.3968C24.3968 22.1401 24.4768 22.1801 24.4768 22.2201V26.4301C24.4768 26.9201 24.0768 27.3101 23.5968 27.3101H23.5868Z"
          fill="#5DDA00"
        />
        <path
          d="M27.2368 24.81H18.7668C17.8768 24.81 17.3468 23.81 17.8568 23.08L20.0568 19.91C19.6268 19.58 19.4668 18.94 19.8168 18.43L22.0768 15.04C22.5168 14.39 23.4768 14.39 23.9068 15.04L26.1668 18.43C26.5168 18.94 26.3568 19.58 25.9268 19.91L28.1268 23.08C28.6368 23.81 28.1168 24.81 27.2268 24.81H27.2368Z"
          fill="#75FF0D"
        />
        <path
          d="M40.9559 33.4902L41.6618 32.7843C43.4461 31 43.4461 28.1078 41.6618 26.3333C40.799 25.4706 39.652 25 38.4363 25C37.2206 25 36.0735 25.4706 35.2108 26.3333L34.5049 27.0392L33.799 26.3333C32.9363 25.4706 31.7892 25 30.5735 25C29.3578 25 28.201 25.4608 27.3382 26.3235C25.5637 28.1078 25.5637 31 27.3382 32.7843L28.0441 33.4902L27.3382 34.1961C25.5539 35.9804 25.5539 38.8726 27.3382 40.6471C28.201 41.5098 29.348 41.9804 30.5637 41.9804C31.7794 41.9804 32.9265 41.5098 33.7892 40.6471L34.4951 39.9412L35.201 40.6471C36.0637 41.5098 37.2108 41.9804 38.4265 41.9804C39.6422 41.9804 40.7892 41.5098 41.652 40.6471C43.4363 38.8627 43.4363 35.9706 41.652 34.1961L40.9461 33.4902H40.9559Z"
          fill="white"
        />
        <path
          d="M37.4362 33.4903L39.9068 31.0197C40.7206 30.206 40.7206 28.8922 39.9068 28.0883C39.0931 27.2844 37.7794 27.2746 36.9755 28.0883L34.5049 30.5589L32.0343 28.0883C31.2206 27.2746 29.9068 27.2746 29.1029 28.0883C28.299 28.902 28.2892 30.2158 29.1029 31.0197L31.5735 33.4903L29.1029 35.9609C28.2892 36.7746 28.2892 38.0883 29.1029 38.8922C29.5049 39.2942 30.0343 39.5001 30.5735 39.5001C31.1127 39.5001 31.6323 39.2942 32.0441 38.8922L34.5147 36.4217L36.9853 38.8922C37.3872 39.2942 37.9166 39.5001 38.4558 39.5001C38.9951 39.5001 39.5147 39.2942 39.9264 38.8922C40.7402 38.0785 40.7402 36.7648 39.9264 35.9609L37.4558 33.4903H37.4362Z"
          fill="#FF3F6F"
        />
      </g>
      <defs>
        <linearGradient
          id={paint0}
          x1="23"
          y1="39"
          x2="23"
          y2="4"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#00FF00" />
          <stop offset="1" stop-color="#99FF00" />
        </linearGradient>
        <linearGradient
          id={paint1}
          x1="22.9968"
          y1="35.63"
          x2="22.9968"
          y2="8"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#005933" />
          <stop offset="1" stop-color="#00BD1E" />
        </linearGradient>
        <clipPath id={clip0}>
          <rect width="46" height="46" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )
}
